import React from 'react';
import { inject, observer } from 'mobx-react';
import FeedbackAttachmentContext from './FeedbackAttachmentContext';
import { useFeedbackAttachments } from './useFeedbackAttachments';

interface FeedbackAttachmentProviderProps {
    setPost?: any;
    children: React.ReactNode;
}

const FeedbackAttachmentProviderInner: React.FC<FeedbackAttachmentProviderProps> = ({
    setPost,
    children,
}) => {
    const attachmentActions = useFeedbackAttachments(setPost);

    return (
        <FeedbackAttachmentContext.Provider value={attachmentActions}>
            {children}
            <input
                ref={attachmentActions.imageInputRef}
                type="file"
                accept="image/*"
                multiple
                style={{ display: 'none' }}
                onChange={attachmentActions.handleImageInputChange}
            />
            <input
                ref={attachmentActions.imageCaptureInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={attachmentActions.handleImageInputChange}
            />
            <input
                ref={attachmentActions.videoInputRef}
                type="file"
                accept="video/*"
                style={{ display: 'none' }}
                onChange={attachmentActions.handleVideoInputChange}
            />
        </FeedbackAttachmentContext.Provider>
    );
};

export default inject('setPost')(observer(FeedbackAttachmentProviderInner));
